<template>
  <ul
    v-if="hasFlashes()"
    class="-my-1"
    ref="flashContainer"
  >
    <li
      v-for="(flash, index) in flashes"
      :key="index"
      class="my-1"
    >
      <adivare-alert
        :type="flash.type"
        :size="size"
        show-icon
        class="cursor-pointer"
        @click="removeFlash(flash.id)"
      >
        <span v-html="flash.message"/>
      </adivare-alert>
    </li>
  </ul>
</template>

<script>
import AdivareAlert from "../../../components/alert";
import { AdivareScrollTo } from '@adivare/js-components';

export default {
  name: "adivare-flashes",
  props: {
    // render all flash messages except messages with particular subjects
    showAllSubjectsExcept: {
      type: Array,
      default: [],
      required: false,
    },
    // render only flash messages with particular subjects
    showOnlySubjects: {
      type: Array,
      default: [],
      required: false,
    },
    // scroll to flash message
    scrollToFlash: {
      type: Boolean,
      default: false,
      required: false,
    },
    // size of alert message
    size: {
      type: String,
      default: 'lg',
      required: false,
      validator: (value) => {
        return [
          'xs',
          'sm',
          'md',
          'lg',
          'xl',
        ].includes(value);
      }
    }
  },
  components: {
    AdivareAlert,
  },
  computed: {
    flashes() {
      const filterMessages = () => {
        if (0 < this.showOnlySubjects.length) {
          return this.$store.getters.getFlashes.filter(message => 'subject' in message && true === this.showOnlySubjects.includes(message.subject));
        }

        if (0 < this.showAllSubjectsExcept.length) {
          return this.$store.getters.getFlashes.filter(message => !('subject' in message) || ('subject' in message && false === this.showAllSubjectsExcept.includes(message.subject)));
        }

        return this.$store.getters.getFlashes;
      }
      const messages = filterMessages();
      if (true === this.scrollToFlash && 0 < messages.length) this.scroller();

      return messages;
    },
  },
  methods: {
    hasFlashes() {
      return this.flashes.length > 0;
    },
    removeFlash(id) {
      this.$store.commit('removeFlash', id);
    },
    scroller() {
      this.$nextTick(() => {
        if (undefined !== this.$refs.flashContainer) AdivareScrollTo.element(this.$refs.flashContainer, -200);
      });
    }
  },
}
</script>
